import { useState } from "react";
import { Link } from "react-router-dom";
import { apiPost } from "../lib/api";
import { AuthLayout } from "../components/AuthLayout";
import { Alert, Button, Field, Input, Spinner } from "../components/ui";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [devLink, setDevLink] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const res = await apiPost("/auth/forgot-password", { email });
      setDevLink(res.devResetLink || "");
      setSent(true);
    } catch (err) {
      setError(err.message || "Couldn't send a reset link. Try again.");
    } finally {
      setBusy(false);
    }
  }

  if (sent) {
    return (
      <AuthLayout title="Check your email">
        <Alert kind="success">
          If there's an account for {email}, a reset link is on its way. It expires in an hour.
        </Alert>
        {devLink && (
          <p className="mt-3 break-all text-xs text-slate-500">
            Dev mode — no email configured. Link: {devLink}
          </p>
        )}
        <p className="mt-4 text-sm text-slate-500">
          <Link to="/gear/login" className="font-semibold text-brand-600">
            Back to sign in
          </Link>
        </p>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Reset your password">
      <p className="text-sm text-slate-500">
        Enter the email you signed up with and we'll send you a link to set a new password.
      </p>
      <form onSubmit={submit} className="mt-4 space-y-3">
        <Field label="Email">
          <Input
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
          />
        </Field>
        <Alert>{error}</Alert>
        <Button type="submit" disabled={busy} className="w-full">
          {busy ? <Spinner /> : "Send reset link"}
        </Button>
      </form>
      <p className="mt-4 text-sm text-slate-500">
        Remembered it?{" "}
        <Link to="/gear/login" className="font-semibold text-brand-600">
          Sign in
        </Link>
      </p>
    </AuthLayout>
  );
}
